export const baseUrl = "https://api.mandtransinc.com"

export default {
  baseUrl
}